import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const CookieSettingsDialog: React.FC = () => {
  const {
    consent,
    settingsOpen,
    closeSettingsDialog,
    updateConsent,
    acceptEssentialOnly,
  } = useCookieConsent();

  const [analytics, setAnalytics] = useState(consent.analytics);
  const [marketing, setMarketing] = useState(consent.marketing);
  const [saving, setSaving] = useState(false);

  React.useEffect(() => {
    if (!settingsOpen) return;
    setAnalytics(consent.analytics);
    setMarketing(consent.marketing);
  }, [settingsOpen, consent.analytics, consent.marketing]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateConsent({ analytics, marketing });
      closeSettingsDialog();
    } finally {
      setSaving(false);
    }
  };

  const handleWithdraw = async () => {
    setSaving(true);
    try {
      await acceptEssentialOnly();
      closeSettingsDialog();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={settingsOpen} onClose={closeSettingsDialog} maxWidth="sm" fullWidth>
      <DialogTitle>Cookie Settings</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Essential cookies are always enabled for authentication and security.
        </Typography>
        <FormControlLabel
          control={<Switch checked disabled />}
          label="Essential cookies (required)"
        />
        <FormControlLabel
          control={<Switch checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />}
          label="Analytics cookies (optional)"
        />
        <FormControlLabel
          control={<Switch checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />}
          label="Marketing cookies (optional)"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleWithdraw} disabled={saving}>Withdraw optional</Button>
        <Button onClick={closeSettingsDialog} disabled={saving}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CookieSettingsDialog;
